export const ACTIONS = {
  SET_AV_SESSION_TOKEN_LOADING: 'SET_AV_SESSION_TOKEN_LOADING',
  SET_AV_SESSION_TOKEN: 'SET_AV_SESSION_TOKEN',
  RESET_AV_SESSION_TOKEN: 'RESET_AV_SESSION_TOKEN',
};

export const setAVSessionTokenLoading = payload => ({
  type: ACTIONS.SET_AV_SESSION_TOKEN_LOADING,
  payload,
});

export const setAVSessionToken = payload => ({
  type: ACTIONS.SET_AV_SESSION_TOKEN,
  payload,
});

export const resetAVSessionToken = () => ({
  type: ACTIONS.RESET_AV_SESSION_TOKEN,
});
